import Application from "./class/main/Application";
import Client from "./class/main/Client";
import Setup from "./class/main/Setup";
import AdvancedWebSocket from "./class/main/WSConnection";

export default {
  Application,
  Client,
  Setup,
  WebSocket: AdvancedWebSocket,
};